import { API_URL } from "@/config/constants";
import { buildUrl } from "@/utils";
import axios from "axios";
import { IFilter, Page } from "../api.types";
import { IExportBase } from "../scopes";
import {
    IAIComparison,
    IAIComparisonProcessingStatus,
    ICompareInChart,
    ICompareInChartCreate,
    ICompareInChartMinimal,
    ICompareInChartUpdate,
} from "./compare-in-chart.types";

const API = `${API_URL}/compare-in-charts`;

export const createCompareInChart = async (
    compareInChartCreate: ICompareInChartCreate
) => {
    const result = await axios.post<ICompareInChart>(API, compareInChartCreate);
    return result.data;
};

export const getCompareInCharts = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter
) => {
    const url = buildUrl(API, { page, size, ...filter });

    const result = await axios.get<Page<ICompareInChartMinimal>>(url);
    return result.data;
};

export const getCompareInChart = async (id: number | string) => {
    const result = await axios.get<ICompareInChart>(`${API}/${id}`);
    return result.data;
};

export const updateCompareInChart = async (
    id: number,
    compareInChartUpdate: ICompareInChartUpdate
) => {
    const result = await axios.put<ICompareInChart>(
        `${API}/${id}`,
        compareInChartUpdate
    );
    return result.data;
};

export const deleteCompareInChart = async (id: number) => {
    const result = await axios.delete(`${API}/${id}`);
    return result.data;
};

export const exportCompareInChart = async (
    id: number,
    chartExportData: IExportBase
) => {
    const clauseParams = chartExportData.clauses
        .map((id) => `clauses=${id}`)
        .join("&");

    const url = buildUrl(`${API}/${id}/export`, {
        export_type: chartExportData.export_type,
        include_guidance: chartExportData.include_guidance,
        include_metadata: chartExportData.include_metadata,
        include_comments: chartExportData.include_comments,
        include_fields: chartExportData.include_fields,
    });

    const result = await axios.get(`${url}&${clauseParams}`, {
        responseType: "blob",
    });

    return result.data;
};

export const getAIComparisonsForChart = async (id: string) => {
    const result = await axios.get<IAIComparison[]>(
        `${API}/${id}/ai-comparisons`
    );
    return result.data;
};

export const getAIComparisonStatus = async (id: string) => {
    const result = await axios.get<IAIComparisonProcessingStatus>(
        `${API}/${id}/ai-comparisons-status`
    );
    return result.data;
};
